import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import Button from '../../components/ButtonCustom';
import { QRCodeScan, ReclaimTransactionCodeIcon } from '../../components/icons';

const useStyles = makeStyles((theme) => ({
    content: {
        marginBottom: theme.spacing(4),
        padding: theme.spacing(3, 0),
        "&:hover": {
            cursor: 'pointer',
        }
    },
    icon: {
        background: theme.palette.primary.main,
        borderRadius: theme.spacing(4),
        textAlign: 'center',
        padding: theme.spacing(2)
    },
}));

export default function ReclaimPurchaseView(props){
    const { t } = useTranslation();
    const classes = useStyles();

    const { onBarCodeQRScan } = props;
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={props.onClose}
                title={t('reclaim_purchase')}
                children={
                    <Grid item >
                        <Grid item xs={12}>
                            <Grid item xs={12} container alignItems='center' spacing={2} className={classes.content} onClick={() => props.onShowDrawer('barcode')}>
                                <Grid item xs={2} xl={1}>
                                    <Grid item xs={12}>
                                        <Grid item className={classes.icon}>
                                            <QRCodeScan />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={10}>
                                    <CustomTypo variant="subtitle1" color="onPrimary">{t('reclaim_purchase_scan')}</CustomTypo>
                                    <CustomTypo variant="body2" color="onPrimary">{t('reclaim_purchase_scan_desc')}</CustomTypo>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems='center' spacing={2} className={classes.content} onClick={() => props.onShowDrawer('transaction_code')}>
                                <Grid item xs={2} xl={1}>
                                    <Grid item xs={12}>
                                        <Grid item className={classes.icon}>
                                            <ReclaimTransactionCodeIcon />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={10} xl={11}>
                                    <CustomTypo variant="subtitle1" color="onPrimary">{t('reclaim_purchase_transaction_code')}</CustomTypo>
                                    <CustomTypo variant="body2" color="onPrimary">{t('reclaim_purchase_transaction_code_desc')}</CustomTypo>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            />
        </div>
    )
}